module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am484-3284f43872d2a4b216564e7b6111fea0.jpg";